"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenHistory = void 0;
const config_1 = require("@app/config");
const token_hooks_1 = require("@hooks/token.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const expandable_grid_1 = __importDefault(require("@shared-modules/components/expandable-grid"));
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const TokenHistory = (props) => {
    const { nft } = props;
    const translator = (0, translation_hooks_1.usePagesTranslation)("tokenPage.tokenHistory");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const scannerUrl = config_1.CONFIG.scannerUrl[nft.chainId.toString() || ""];
    const { list, setPage, loaderState } = (0, token_hooks_1.useTokenHistory)(nft.tokenId, { sorting: "desc" });
    return (react_1.default.createElement(expandable_grid_1.default, { columns: (0, helper_1.getCells)(translator, commonTranslator, scannerUrl), data: list, minWidth: "850px", getDataId: ({ date }) => date, onPageChange: setPage, totalRows: loaderState.total || 0, pageSize: loaderState.size }));
};
exports.TokenHistory = TokenHistory;
